import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import styles from './checkmark.module.scss';

const propTypes = {
  active: PropTypes.bool
};

const CheckmarkSVG = ({active}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="10"
    viewBox="0 0 11 10"
    className={classNames({
      [styles.checkmark]: true,
      [styles['checkmark--active']]: active
    })}>
    <path fill="none" fillRule="evenodd" strokeWidth="2" d="M1 5l3 3 6-7" />
  </svg>
);

CheckmarkSVG.propTypes = propTypes;

export default CheckmarkSVG;
